import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'

export default function PlaceForm({ place }) {
  const [name, setName] = useState(place.name)
  const [address, setAddress] = useState(place.address)

  return (
    <div>
      <Form method="POST" onSubmit={() => false}>
        <Form.Group controlId="formBasicEmail">
          <Form.Label>Nome</Form.Label>
          <Form.Control type="text" name="name" value={name} onChange={(e) => setName(e.target.value)}
          // ref={register} onChange={(e) => setNumber(e.target.value)} onFocus={handleFocus} 
          />
        </Form.Group>

        <Form.Group controlId="formBasicPassword">
          <Form.Label>Endereço</Form.Label>
          <Form.Control type="text" name="address" value={address} onChange={(e) => setAddress(e.target.value)}
          // ref={register} onChange={(e) => setName(e.target.value)} onFocus={handleFocus} 
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="float-right" style={{marginBottom: '1rem'}}>
          Salvar
        </Button>
      </Form>
    </div>
  )
}
